import type { Service } from '../types/content'

export const services: Service[] = [
  {
    id: 'tax',
    index: '01',
    name: 'Tax Advisory & Compliance',
    description:
      "We help clients stay tax compliant through preventive checks that mitigate and minimise tax risk exposure — plus in-house training to build your team's own capability.",
    items: [
      'Tax advisory & compliance',
      'Tax health checks',
      'Tax due diligence',
      'VAT refunds',
      'Deferred tax computations',
      'Business structuring for tax',
      'Tax audits & investigations',
      'Dispute resolution & correspondence',
    ],
  },
  {
    id: 'audit',
    index: '02',
    name: 'Audit & Assurance',
    description:
      'Project, statutory, system and forensic audits delivered with strict observation of ethical standards and professional due care.',
    items: [
      'Internal audit services',
      'Statutory & independence audit',
      'Risk & governance assurance',
      'Due diligence & capacity assessment',
      'Internal controls assurance',
      'Audit expertise across industries',
    ],
  },
  {
    id: 'accounting',
    index: '03',
    name: 'Accounting & Payroll',
    description:
      'From day-to-day bookkeeping to acting as your reporting accountants — plus full payroll bureau services and statutory compliance.',
    items: [
      'Bookkeeping & ledgers',
      'Bank reconciliation',
      'Financial statements',
      'Budgeting & management accounting',
      'Payroll processing',
      'Statutory compliance',
    ],
  },
  {
    id: 'forensic',
    index: '04',
    name: 'Forensic & Investigations',
    description:
      "When something doesn't add up, our forensic accountants trace it — supporting dispute resolution from evidence to conclusion.",
    items: [
      'Fraud & financial crime investigation',
      'Forensic accounting & audits',
      'Dispute resolution support',
      'Due diligence',
    ],
  },
  {
    id: 'advisory',
    index: '05',
    name: 'Business & Finance Advisory',
    description:
      'Investment advisory to help clients get the best return, including support through grants and grants management.',
    items: [
      'Financial planning & management',
      'Corporate finance advisory',
      'Governance, risk & compliance',
      'Receivable management',
      'Debt financing advisory',
      'Investment & grants advisory',
    ],
  },
  {
    id: 'mel',
    index: '06',
    name: 'Monitoring, Evaluation & Learning',
    description:
      'Qualitative and quantitative data collection, analysis and reporting for government, NGO and faith-based project work.',
    items: [
      'Baseline & endline surveys',
      'Project planning & M&E',
      'Data collection & analysis',
      'Database management',
      'Situational analysis',
      'Donor reporting & presentation',
    ],
  },
]
